import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

import { Subscription } from 'rxjs/Subscription';

import { Event } from '../models/event';
import { User } from '../models/user';

import { EventService } from '../services/event.service';
import { UserService } from '../services/user.service';
declare var jQuery: any;

@Component({
  selector: 'app-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.css']
})
export class EventsListComponent implements OnInit, OnDestroy {

  user$?: FirebaseObjectObservable<User | null>;
  company$?: FirebaseObjectObservable<User | null>;
  companySubscription?: Subscription;
  events$?: FirebaseListObservable<Event[]>;
  isSubmitting = false;
  formValues: FormValues = {
    name: null,
    startTimestamp: null,
    endTimestamp: null,
    selectedFeatures: []
  };
  features1 = [
    {
      'key': 'Tickets'
    },
    {
      'key': 'Schedule'
    },
    {
      'key': 'My Agenda'
    },
    {
      'key': 'Speakers'
    },
    {
      'key': 'News Feed'
    },
    {
      'key': 'Social Feed'
    },
    {
      'key': 'Feedback Form'
    }

  ];
  features2 = [
    {
      'key': 'Trade X'
    },
    {
      'key': 'Sponsors'
    },
    {
      'key': 'Exhibitors'
    },
    {
      'key': 'Leaderboard'
    },
    {
      'key': 'Documents'
    },
    {
      'key': 'FAQs'
    },
    {
      'key': 'Networking'
    },
    {
      'key': 'Poll'
    },
    {
      'key': 'Camera Filters'
    }
  ];


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private userService: UserService,
  ) { }

  ngOnInit() {
    const user$ = this.userService.getCurrentUser();

    if (user$) {
      this.user$ = user$;
    }

    this.route.data.subscribe((data: { user$: FirebaseObjectObservable<User | null> | null }) => {
      if (!data.user$) {
        return;
      }

      if (this.companySubscription) {
        this.companySubscription.unsubscribe();
      }

      this.company$ = data.user$;
      this.companySubscription = this.company$.subscribe(user => {
        if (user) {
          this.events$ = this.eventService.getEvents({
            orderByChild: Event.PropertyKey.companyId,
            equalTo: user.id,
          });

          this.events$.first().subscribe(events => {
            for (const event of events) {
              if (event) {
                //COMMENT OUT THIS LINE TO REMOVE REDIRECT
                //this.router.navigate(['../events/' + event.id + '/info'], { relativeTo: this.route });
              }
            }

          })
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
  }

  onFeatureCheck(feature: string) {

    if (!this.formValues.selectedFeatures.includes(feature)) {
      this.formValues.selectedFeatures.push(feature);
    } else {
      this.formValues.selectedFeatures.splice(this.formValues.selectedFeatures.indexOf(feature), 1);
    }
  }

  onSubmitForm() {
    if (this.isSubmitting || !this.user$) { return; }

    this.isSubmitting = true;

    this.user$.first().subscribe(async (user: User | null) => {
      if (!user) {
        this.isSubmitting = false;
        return;
      }

      try {

        let id: string;

        id = await this.eventService.setEvent(this.formValues, user.id);

        alert('Saved.');

        jQuery('#addEvent').modal('hide');

        this.router.navigate(['../events/' + id + '/info'], { relativeTo: this.route });

      } catch (error) {
        alert(error.message || error);
      }

      this.isSubmitting = false;
    });
  }

}

export interface FormValues {
  name: string | null;
  startTimestamp: string | null;
  endTimestamp: string | null;
  selectedFeatures: string[];
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/events/events-list.component.ts